import { generateRandomNumber } from "@/lib/Common"
import dayjs from "@/lib/dayjs";
import { useEffect, useState } from "react"
import { BidBadge } from "./BidBadge"
import { TbClockHour3 } from "react-icons/tb"

export function CustomProdDescCountdown({
  children,
  targetTime,
  currentBid,
  className,
  gunbrokerId,
  ...props
}) {
  const [currentTime, setCurrentTime] = useState(dayjs.utc())
  const [timeLeft, setTimeLeft] = useState(
    dayjs.duration(targetTime.diff(dayjs.utc()))
  )
  const [variant, setVariant] = useState()

  const formatTimePart = (value) => {
    return value.toString().padStart(2, "0")
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs.utc()
      setCurrentTime(now)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const newTimeBetween = dayjs.duration(targetTime.diff(currentTime))
    setTimeLeft(newTimeBetween)
    let badgeVariant = "default"
    if (newTimeBetween.asHours() < 24) {
      if (newTimeBetween.asHours() <= 0) {
        badgeVariant = "lastcall"
      } else if (newTimeBetween.asHours() < 2) {
        badgeVariant = "danger"
      } else {
        badgeVariant = "warning"
      }
    }
    if (badgeVariant === "lastcall") {
      // Retrieve the current array from localStorage or initialize an empty array
      const currentIds = JSON.parse(
        localStorage.getItem("lastCallGunbrokerIds") || "[]"
      )
      if (!currentIds.includes(gunbrokerId) && gunbrokerId !== null) {
        currentIds.push(gunbrokerId)
        localStorage.setItem("lastCallGunbrokerIds", JSON.stringify(currentIds))
      }
    }
    setVariant(badgeVariant)
  }, [currentTime, targetTime])

  const displayTime =
    variant === "lastcall"
      ? "Last Call!"
      : timeLeft.asSeconds() >= 0
      ? timeLeft.days() > 0
        ? `${timeLeft.days()} day${timeLeft.days() > 1 ? "s" : ""}`
        : `${formatTimePart(timeLeft.hours())}:${formatTimePart(
            timeLeft.minutes()
          )}:${formatTimePart(timeLeft.seconds())}`
      : "00:00:00"

  const displayLabel = variant === "lastcall" ? "" : "Time Left"

  return (
    variant && (
      <BidBadge variant={variant} className={className} {...props}>
        <span className="hidden sm:block flex items-center justify-between w-full">
          <TbClockHour3 className="inline-block w-[19px] h-[19px] me-[14px] text-white" />
          <span
            className="font-normal text-[19px]"
            style={{ marginRight: "5px" }}
          >
            {displayLabel}
          </span>
          <span className="font-semibold text-[19px]">{displayTime}</span>
        </span>
        {currentBid !== undefined && variant === "lastcall" && (
          <span className="hidden sm:block font-normal text-[17px] text-right flex items-center w-full">
            Current Bid{" "}
            <span className="font-semibold text-[17px]">
              ${currentBid ? currentBid.toLocaleString() : "0"}
            </span>
          </span>
        )}
        {currentBid !== undefined && variant !== "lastcall" && (
          <span className="hidden sm:block font-normal text-[17px] text-right items-center w-full">
            Current Bid{" "}
            <span className="font-semibold text-[17px]">
              ${currentBid ? currentBid.toLocaleString() : "0"}
            </span>
          </span>
        )}

        <span className="inline-block sm:hidden flex justify-between items-center w-full">
          <TbClockHour3 className="inline-block w-[50px] h-[50px] me-[12px] text-white" />
          <span className="inline-block font-semibold text-[12px]  w-full">
            {displayTime}{" "}
          </span>
          {currentBid !== undefined && (
            <span className="block sm:hidden font-normal text-[14px] text-right items-center w-full">
              <span> Bid </span>$
              {currentBid ? currentBid.toLocaleString() : "0"}
            </span>
          )}
        </span>
      </BidBadge>
    )
  )
}
